import PropTypes from "prop-types";
import React from "react";
import {
  renderLogoRPLeftPartnerRight,
  renderAwardTextTKD,
  renderOneSignatureForTKD
} from "../common/certificate";

const Template = ({ document }) => (
  <div>
    <div
      className="container"
      style={{ border: 0, borderColor: "#AAA", borderStyle: "solid" }}
    >
      {renderLogoRPLeftPartnerRight("TKD")}
      {renderAwardTextTKD(document)}
      {renderOneSignatureForTKD(document)}
    </div>
  </div>
);

Template.propTypes = {
  document: PropTypes.object.isRequired
};
export default Template;
